import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { CatalogList } from '@components/organisms/CatalogList'
import { OrderBy, useGetCatalogsQuery } from '@services/cloud/client'

type Category = {
  catalogFirstDepthCategoryId: string | null | undefined
  catalogSecondDepthCategoryId: string | null | undefined
  catalogThirdDepthCategoryId: string | null | undefined
}

type Props = {
  category: Category
}

export const RelateCatalogs = (props: Props) => {
  const { data, loading } = useGetCatalogsQuery({
    variables: {
      args: {
        where: {
          firstDepthCategoryId: props.category.catalogFirstDepthCategoryId as string,
          secondDepthCategoryId: props.category.catalogSecondDepthCategoryId as string,
          thirdDepthCategoryId: props.category.catalogThirdDepthCategoryId as string,
        },
        limit: 12,
        skip: 0,
        orderBy: OrderBy.Desc,
      },
    },
  })

  if (loading) {
    return null
  }

  return (
    <>
      {data?.catalogs && Array.isArray(data?.catalogs) && data?.catalogs.length > 0 && (
        <Box mt={5}>
          <Typography fontWeight="bold" variant="subtitle1">
            関連するカタログ
          </Typography>
          <Grid container={true} spacing={1}>
            {data?.catalogs.map((catalog) => (
              <Grid key={catalog?.catalogId} item={true} xs={6} sm={4} md={3}>
                <CatalogList catalog={catalog} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </>
  )
}
